import { render, staticRenderFns } from "./CrudStockLocation.vue?vue&type=template&id=4581fd6a&scoped=true"
import script from "./CrudStockLocation.vue?vue&type=script&lang=js"
export * from "./CrudStockLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581fd6a",
  null
  
)

export default component.exports